import { FiUsers } from "react-icons/fi";
import { RiPoliceCarLine } from "react-icons/ri";
import ManageLink from "../../components/shared/ManageLink";
import { IoLinkOutline } from "react-icons/io5";

export default function Manage({
  children,
  title,
  subtitle,
  description,
  actions,
}: any) {
  const menus = [
    {
      id: 1,
      to: "/manage/customers",
      name: "Customers",
      icon: <FiUsers />,
    },
    {
      id: 2,
      to: "/manage/vehicles",
      name: "Vehicles",
      icon: <RiPoliceCarLine />,
    },
    {
      id: 3,
      to: "/manage/users",
      name: "Users",
      icon: <FiUsers />,
    },
    {
      id: 3,
      to: "/manage/models",
      name: "Models",
      icon: <RiPoliceCarLine />,
    },
    {
      id: 4,
      to: "/manage/sources",
      name: "Sources",
      icon: <IoLinkOutline />,
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-0 m-4 border rounded-lg ">
      <div className="bg-gray-50 col-span-2 rounded-l-lg border-r">
        {menus?.map((menu: any, index: number) => (
          <ManageLink to={`${menu?.to}`} icon={menu?.icon} key={index}>
            {menu?.name}
          </ManageLink>
        ))}
      </div>
      <div className="bg-white col-span-10 h-full rounded-r-lg">
        <div className="border-b p-4 flex justify-between items-center h-18">
          <div className="flex justify-center items-center">
            <div className="">
              <span className="text-lg font-bold">{title} : </span>
              <span>{subtitle}</span>
              <div className="">{description}</div>
            </div>
          </div>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}
